import { Button, Tabs, notification } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import SettingsTabView from '../../components/SettingsTabView';
import DynamicProperties from '../common/DynamicProperties';
import {
  getPageItemOperations,
  getGlobalSettingsPageInfo,
  putGlobalSettingsWidgetGroup,
  putGlobalSettingsWidgetInfo,
  putGlobalSettingsWidgets
} from '../../redux/actions/settings';
import { ITEM_OPERATIONS } from '../../util/GlobalConstant';
import { returnFraudUserAccessByResource } from '../../util/TmFraudModuleFilter';
import {
  FRAUD_IAD_TAB_LIST,
  FRAUD_IAD_TAB_PAGEID_LIST,
  TM_FRAUD_IAD_TAB_LIST,
  TM_FRAUD_IAD_TAB_PAGEID_LIST,
  TM_IAD_TAB_LIST,
  TM_IAD_TAB_MODULE_ID,
  TM_IAD_TAB_MODULE_NAME,
  TM_IAD_TAB_PAGEID_LIST,
  TM_IAD_TAB_SUBMODULE
} from '../constants/trmConstants';
import {
  CURRENT_PIPELINES_DETAILS_PAGE_ID,
  DYNAMIC_PROPERTIES_DETAILS_PAGE_ID,
  NS_SETTINGS_TAB_MODULE_ID,
  NS_SETTING_TAB_SUBMODULE,
  NS_IAD_TAB_MODULE_NAME,
  TS_SETTINGS_TAB_MODULE_ID,
  TS_SETTING_TAB_SUBMODULE,
  CRS_SETTINGS_TAB_MODULE_ID,
  CRS_SETTING_TAB_SUBMODULE,
  CRS_IAD_TAB_MODULE_NAME,
  DYNAMIC_PROPERTIES_TAB,
  CURRENT_PIPELINES_TAB
} from '../constants/globalConstants';
import AddNewGroupModal from './AddNewGroupModal';
import GroupPanel from './GroupPanel';
import style from './index.scss';
import {
  convertAPIResponseToState,
  convertToAPIRequestBody,
  parseColumnNames,
  toggleGroupVisibility,
  updateGroup
} from './settingsUtil';
import WidgetTree from './WidgetTree';
import Pipelines from '../common/Pipelines';
import { StyledTab } from './styled';
import CreateSegementSets from './createSegmentSets/CreateSegementSets';
import { isResourceAvailable } from '../../util';
import { getSelectedResources } from '../../util/resourceManager';

const { TabPane } = Tabs;
const sectionHashPrefix = 'section';
const {
  trmResources,
  CRS_UI_DYNPROPS,
  CRS_UI_PIPELINES,
  NS_UI_DYNPROPS,
  NS_UI_PIPELINES,
  TM_UI_DYNPROPS,
  TM_UI_PIPELINES,
  TS_UI_DYNPROPS,
  TS_UI_PIPELINES
} = getSelectedResources();

class Settings extends React.Component {
  constructor(props) {
    super(props);
    const defaultIndex = +(
      window?.location?.hash?.split(sectionHashPrefix)?.[1] ||
      window?.location?.hash?.slice(-1) ||
      0
    );

    this.state = {
      isAddGroupModalShown: false,
      groups: [],
      isDataFetched: false,
      //to-do api integration
      widgetGroups: [],
      widgets: [],
      defaultIndex: defaultIndex,
      selectedTab: defaultIndex,
      isTMuser: false,
      isFraud: false,
      tabPageIdList: [],
      tabList: [],
      createSegmentSetAccess: false
    };
  }

  getIsDynamicPropertiesTabSelected = (tabPageId) =>
    (tabPageId || this.state.tabPageIdList[this.state.selectedTab]) ===
    DYNAMIC_PROPERTIES_DETAILS_PAGE_ID;

  getIsCurrentPipelinesTabSelected = (tabPageId) =>
    (tabPageId || this.state.tabPageIdList[this.state.selectedTab]) ===
    CURRENT_PIPELINES_DETAILS_PAGE_ID;

  getIsGlobalSettingsPageInfoRequired = (tabPageId) => {
    return (
      !this.getIsDynamicPropertiesTabSelected(tabPageId) &&
      !this.getIsCurrentPipelinesTabSelected(tabPageId)
    );
  };

  componentDidMount() {
    const {
      dispatch,
      authentication,
      nsTabList,
      nsTabPageIdList,
      GlobalSettingPageType,
      tmTabPageIdList,
      tmTabList,
      crsTabList,
      crstabPageIdList
    } = this.props;
    const { selectedTab } = this.state;

    const userAccess = returnFraudUserAccessByResource(
      authentication.data,
      trmResources.APP_3_RESOURCE_UI_TM_GLOBAL_SETTINGS,
      ITEM_OPERATIONS.FULL
    );
    const hasCreateSegmentSetAccess = isResourceAvailable(
      authentication,
      trmResources.APP_3_RESOURCE_UI_SEGMENT_DETAILS
    );

    this.setState({
      isTMuser: userAccess.isTMuser,
      isFraud: userAccess.isFraud,
      createSegmentSetAccess: hasCreateSegmentSetAccess
    });

    //Function to display Dynprops and pipelines pages as per the resource access
    const settingsTabsResourceAccess = (uiResources, tabList, pageIdList) => {
      const tabs = [...tabList];
      const tabsList = [...pageIdList];
      if (authentication.data) {
        for (const resourceObj of uiResources) {
          for (const item of authentication.data) {
            if (
              item.details.resource.resourceCode === resourceObj?.resource ||
              item.details.resource.operations?.includes(resourceObj?.resource)
            ) {
              tabs.unshift(resourceObj?.tabName);
              tabsList.unshift(resourceObj?.pageId);
            }
          }
        }
        // Check if 'Dynamic Properties' is present in the array
        const dynamicPropertiesIndex = tabs.indexOf('Dynamic Properties');
        // If 'Dynamic Properties' is present, move it to the beginning
        if (dynamicPropertiesIndex !== -1) {
          // Remove 'Dynamic Properties' from its current position
          tabs.splice(dynamicPropertiesIndex, 1);
          tabsList.splice(dynamicPropertiesIndex, 1);
          // Add 'Dynamic Properties' at the beginning of the array
          tabs.unshift(DYNAMIC_PROPERTIES_TAB);
          tabsList.unshift(DYNAMIC_PROPERTIES_DETAILS_PAGE_ID);
        }
        this.setState({ tabList: tabs, tabPageIdList: tabsList });
      }
      return;
    };

    if (GlobalSettingPageType === 'NS') {
      console.log('GLOB', GlobalSettingPageType);
      const uiResources = [
        {
          resource: NS_UI_DYNPROPS,
          tabName: DYNAMIC_PROPERTIES_TAB,
          pageId: DYNAMIC_PROPERTIES_DETAILS_PAGE_ID
        },
        {
          resource: NS_UI_PIPELINES,
          tabName: CURRENT_PIPELINES_TAB,
          pageId: CURRENT_PIPELINES_DETAILS_PAGE_ID
        }
      ];
      settingsTabsResourceAccess(uiResources, nsTabList, nsTabPageIdList);
      this.setState(
        {
          moduleId: NS_SETTINGS_TAB_MODULE_ID,
          subModule: NS_SETTING_TAB_SUBMODULE,
          moduleName: NS_IAD_TAB_MODULE_NAME
        },
        () => {
          if (dispatch) {
            dispatch(
              getPageItemOperations({
                pageId: this.state.tabPageIdList[selectedTab]
              })
            );
            dispatch(
              getGlobalSettingsPageInfo({
                pageId: this.state.tabPageIdList[selectedTab]
              })
            );
          }
        }
      );
    } else if (GlobalSettingPageType === 'TS') {
      console.log('GLOB', GlobalSettingPageType);
      const uiResources = [
        {
          resource: TS_UI_DYNPROPS,
          tabName: DYNAMIC_PROPERTIES_TAB,
          pageId: DYNAMIC_PROPERTIES_DETAILS_PAGE_ID
        },
        {
          resource: TS_UI_PIPELINES,
          tabName: CURRENT_PIPELINES_TAB,
          pageId: CURRENT_PIPELINES_DETAILS_PAGE_ID
        }
      ];
      settingsTabsResourceAccess(uiResources, nsTabList, nsTabPageIdList);
      this.setState(
        {
          moduleId: TS_SETTINGS_TAB_MODULE_ID,
          subModule: TS_SETTING_TAB_SUBMODULE
        },
        () => {
          if (dispatch) {
            dispatch(
              getPageItemOperations({
                pageId: this.state.tabPageIdList[selectedTab]
              })
            );
            dispatch(
              getGlobalSettingsPageInfo({
                pageId: this.state.tabPageIdList[selectedTab]
              })
            );
          }
        }
      );
    } else if (GlobalSettingPageType === 'CRS') {
      const uiResources = [
        {
          resource: CRS_UI_DYNPROPS,
          tabName: DYNAMIC_PROPERTIES_TAB,
          pageId: DYNAMIC_PROPERTIES_DETAILS_PAGE_ID
        },
        {
          resource: CRS_UI_PIPELINES,
          tabName: CURRENT_PIPELINES_TAB,
          pageId: CURRENT_PIPELINES_DETAILS_PAGE_ID
        }
      ];
      settingsTabsResourceAccess(uiResources, crsTabList, crstabPageIdList),
        this.setState(
          {
            moduleId: CRS_SETTINGS_TAB_MODULE_ID,
            subModule: CRS_SETTING_TAB_SUBMODULE,
            moduleName: CRS_IAD_TAB_MODULE_NAME
          },
          () => {
            if (dispatch) {
              dispatch(
                getPageItemOperations({
                  pageId: this.state.tabPageIdList[selectedTab]
                })
              );
              dispatch(
                getGlobalSettingsPageInfo({
                  pageId: this.state.tabPageIdList[selectedTab]
                })
              );
            }
          }
        );
    } else if (GlobalSettingPageType === 'TM') {
      this.setState(
        {
          tabPageIdList: tmTabPageIdList,
          tabList: tmTabList
        },
        () => {
          if (dispatch) {
            dispatch(
              getPageItemOperations({
                pageId: this.state.tabPageIdList[selectedTab]
              })
            );
            dispatch(
              getGlobalSettingsPageInfo({
                pageId: this.state.tabPageIdList[selectedTab]
              })
            );
          }
        }
      );
    } else if (GlobalSettingPageType === 'TMIAD') {
      const uiResources = [
        {
          resource: TM_UI_DYNPROPS,
          tabName: DYNAMIC_PROPERTIES_TAB,
          pageId: DYNAMIC_PROPERTIES_DETAILS_PAGE_ID
        },
        {
          resource: TM_UI_PIPELINES,
          tabName: CURRENT_PIPELINES_TAB,
          pageId: CURRENT_PIPELINES_DETAILS_PAGE_ID
        }
      ];
      settingsTabsResourceAccess(
        uiResources,
        TM_IAD_TAB_LIST,
        TM_IAD_TAB_PAGEID_LIST
      );
      if (userAccess.isTMuser && !userAccess.isFraud) {
        this.setState(
          {
            moduleId: TM_IAD_TAB_MODULE_ID,
            subModule: TM_IAD_TAB_SUBMODULE,
            moduleName: TM_IAD_TAB_MODULE_NAME
          },
          () => {
            const isGlobalSettingsPageInfoRequired =
              this.getIsGlobalSettingsPageInfoRequired(
                TM_IAD_TAB_PAGEID_LIST[selectedTab]
              );

            if (dispatch && isGlobalSettingsPageInfoRequired) {
              dispatch(
                getPageItemOperations({
                  pageId: this.state.tabPageIdList[selectedTab]
                })
              );
              dispatch(
                getGlobalSettingsPageInfo({
                  pageId: this.state.tabPageIdList[selectedTab]
                })
              );
            }
          }
        );
      } else if (!userAccess.isTMuser && userAccess.isFraud) {
        this.setState(
          {
            tabPageIdList: FRAUD_IAD_TAB_PAGEID_LIST,
            tabList: FRAUD_IAD_TAB_LIST
          },
          () => {
            if (dispatch) {
              dispatch(
                getPageItemOperations({
                  pageId: this.state.tabPageIdList[selectedTab]
                })
              );
              dispatch(
                getGlobalSettingsPageInfo({
                  pageId: this.state.tabPageIdList[selectedTab]
                })
              );
            }
          }
        );
      } else if (userAccess.isTMuser && userAccess.isFraud) {
        this.setState(
          {
            tabPageIdList: TM_FRAUD_IAD_TAB_PAGEID_LIST,
            tabList: TM_FRAUD_IAD_TAB_LIST
          },
          () => {
            if (dispatch) {
              dispatch(
                getPageItemOperations({
                  pageId: this.state.tabPageIdList[selectedTab]
                })
              );
              dispatch(
                getGlobalSettingsPageInfo({
                  pageId: this.state.tabPageIdList[selectedTab]
                })
              );
            }
          }
        );
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { settings, dispatch } = this.props;
    const { selectedTab, tabPageIdList } = this.state;

    const { isDataFetched, groups } = this.state;
    if (settings) {
      const { configuration } = settings;
      if (
        configuration &&
        configuration.isSaved !== prevProps.settings.configuration.isSaved &&
        configuration.isSaved
      ) {
        notification.open({
          message: (
            <p>
              <i style={{ color: '#2ecc71' }} className="fa fa-check"></i>
              &nbsp;&nbsp;Saved Successfully!
            </p>
          ),
          description: 'Settings has been saved.'
        });
        dispatch(
          getGlobalSettingsPageInfo({
            pageId: tabPageIdList[selectedTab]
          })
        );
        this.setState({ isDataFetched: false });
      }

      if (configuration && configuration.error) {
        const errorMessage =
          configuration.error?.error?.data || 'Please try again.';
        notification.open({
          message: (
            <p>
              <i style={{ color: '#e74c3c' }} className="fa fa-close"></i>
              &nbsp;&nbsp;Something went wrong
            </p>
          ),
          description: errorMessage
        });
      }

      // set data to state if it has not been fetched before
      if (!isDataFetched && configuration && configuration.data) {
        const configData = configuration.data;
        const parsedResponse = convertAPIResponseToState(configData);
        const { selectedAlertWidgetGroup, selectedAlertWidget } = this.state;
        console.log(
          'parsedResponse =>',
          parsedResponse,
          'selectedAlertWidgetGroup ==>',
          selectedAlertWidgetGroup
        );
        const defWidgets =
          parsedResponse[
            selectedAlertWidgetGroup
              ? parsedResponse.findIndex(
                  (wg) => wg.groupName === selectedAlertWidgetGroup
                )
              : 0
          ]?.widgets;
        const defGroups =
          defWidgets?.[
            selectedAlertWidget
              ? defWidgets.findIndex(
                  (wg) => wg.groupName === selectedAlertWidget
                )
              : 0
          ]?.groups;

        if (Array.isArray(parsedResponse) && parsedResponse.length > 0) {
          this.setState({
            isDataFetched: true,
            widgetGroups: parsedResponse,
            selectedAlertWidgetGroup:
              selectedAlertWidgetGroup || parsedResponse[0].groupName,
            widgets: defWidgets,
            selectedAlertWidget:
              selectedAlertWidget || parsedResponse[0].widgets[0]?.groupName,
            groups: defGroups || []
          });
        }
      }
    }
  }

  onSaveSettings = () => {
    const { dispatch } = this.props;
    const {
      groups,
      selectedTab,
      selectedAlertWidgetGroup,
      selectedAlertWidget,
      tabPageIdList
    } = this.state;
    if (dispatch) {
      const params = {
        widgetGroupId: selectedAlertWidgetGroup,
        widgetId: selectedAlertWidget,
        widgetName: selectedAlertWidget,
        widgetIndex: this.state.widgets.findIndex(
          (w) => w.groupName === selectedAlertWidget
        ),
        isVisible: true
      };
      dispatch(
        putGlobalSettingsWidgetInfo({
          data: convertToAPIRequestBody(groups, true, params)
        })
      );

      dispatch(
        putGlobalSettingsWidgetGroup({
          params: {
            pageId: tabPageIdList[selectedTab]
          },
          data: {
            widgetGroups: this.state.widgetGroups.map((widgetGroup, index) => {
              return {
                pageId: tabPageIdList[selectedTab],
                groupId: widgetGroup.groupName,
                groupIndex: index
              };
            })
          }
        })
      );
      dispatch(
        putGlobalSettingsWidgets({
          params: {
            widgetGroupId: selectedAlertWidgetGroup
          },
          data: {
            widgets: this.state.widgets.map((widget, index) => {
              return {
                widgetId: widget.groupName,
                isVisible: true,
                widgetIndex: index
              };
            })
          }
        })
      );
    }

    this.setState({
      isSaving: true
    });
  };

  onToggleAddGroupModal = () => {
    const { isAddGroupModalShown } = this.state;
    this.setState({
      isAddGroupModalShown: !isAddGroupModalShown
    });
  };

  onConfirmAddGroup = (group) => {
    const { groups } = this.state;
    const updatedGroups = [...groups, group];

    this.setState(
      {
        isAddGroupModalShown: false,
        groups: updatedGroups
      },
      () => {
        this.onSaveSettings();
      }
    );
  };

  onDeleteGroup = (groupIndex) => {
    const { groups } = this.state;
    const updatedGroups = [];

    if (Array.isArray(groups)) {
      groups.forEach((groupItem, currentGroupIndex) => {
        if (currentGroupIndex !== groupIndex) {
          updatedGroups.push(groupItem);
        }
      });

      this.setState(
        {
          groups: updatedGroups
        },
        () => {
          this.onSaveSettings();
        }
      );
    }
  };

  onToggleGroupVisibility = (groupIndex) => {
    const { groups } = this.state;
    if (Array.isArray(groups)) {
      const currentGroup = groups[groupIndex];
      if (currentGroup) {
        const updatedGroups = toggleGroupVisibility(groupIndex, groups);
        this.setState(
          {
            groups: updatedGroups
          },
          () => {
            this.onSaveSettings();
          }
        );
      }
    }
  };

  renderGroupCards = () => {
    const { groups, selectedAlertWidget, selectedAlertColumn } = this.state;
    const { settings } = this.props;
    const { widgetItemOperations } = settings;
    // populate column names dropdown options
    let columnNames = parseColumnNames(
      selectedAlertWidget,
      widgetItemOperations
    );

    // get dictionary for item to labels
    const labelDictionary = groups
      .map((group) => group.items)
      .flat()
      .reduce((org, item) => {
        if (item) {
          org[item.itemName] = item.labelName;
        }
        return org;
      }, {});

    if (Array.isArray(groups) && groups.length > 0) {
      let groupCards = [];
      groupCards = groups.map((groupItem, groupIndex) => {
        const groupItems = groupItem.items;
        return (
          <div
            className={style.cardContainer}
            style={{
              display:
                !selectedAlertColumn ||
                selectedAlertColumn === groupItem.columnId
                  ? 'inherit'
                  : 'none'
            }}
            key={'GroupPanel-' + groupIndex}>
            <GroupPanel
              groups={groups}
              columnNames={columnNames}
              groupIndex={groupIndex}
              onBatchUpdateItems={this.onBatchUpdateGroupItems}
              onUpdateGroup={this.onUpdateGroup}
              groupItem={groupItem}
              items={groupItems}
              onDeleteGroup={this.onDeleteGroup}
              onToggleGroupVisibility={this.onToggleGroupVisibility}
              labelDictionary={labelDictionary}
            />
          </div>
        );
      });

      return groupCards;
    }

    return null;
  };

  onSortGroups = (groupItems) => {
    this.setState({
      groups: groupItems
    });
  };
  onSortWidgets = (groupItems) => {
    this.setState({
      widgets: groupItems
    });
  };

  onSortWidgetGroups = (groupItems) => {
    this.setState({
      widgetGroups: groupItems
    });
  };

  onBatchUpdateGroupItems = (items, groupIndex, isSaving) => {
    const { groups } = this.state;
    const selectedGroup = groups[groupIndex];

    if (Array.isArray(items) && selectedGroup) {
      // update group
      const updatedGroups = groups.map((currentGroup, currentGroupIndex) => {
        if (currentGroupIndex === groupIndex) {
          return {
            ...selectedGroup,
            items: items
          };
        } else {
          return currentGroup;
        }
      });

      this.setState(
        {
          groups: updatedGroups
        },
        () => {
          if (isSaving) {
            this.onSaveSettings();
          }
        }
      );
    }
  };

  onUpdateGroup = (group, groupIndex, isSaving) => {
    const { groups } = this.state;
    if (group) {
      const updatedGroups = updateGroup(group, groupIndex, groups);
      this.setState(
        {
          groups: updatedGroups
        },
        () => {
          if (isSaving) {
            this.onSaveSettings();
          }
        }
      );
    }
  };

  onAlertSelectColumn = ({ groupName: column }) => {
    this.setState({ selectedAlertColumn: column });
  };

  onAlertSelectWidget = ({ groupName }) => {
    const { selectedTab } = this.state;
    const { dispatch } = this.props;
    const groups = this.state.widgets.find(
      (w) => w.groupName === groupName
    )?.groups;

    if (groups) {
      this.setState({
        selectedAlertWidget: groupName,
        groups,
        selectedAlertColumn: null
      });
    } else {
      const widgetGroup = this.state.widgetGroups.find((wg) =>
        wg.widgets.find((w) => w.groupName === groupName)
      );
      const widgets = widgetGroup.widgets;
      const widgetConfig = widgets.find(
        (w) => w.groupName === groupName
      )?.groups;
      this.setState({
        selectedAlertWidgetGroup: widgetGroup.groupName,
        widgets,
        selectedAlertWidget: groupName,
        selectedAlertColumn: null,
        groups: widgetConfig
      });
    }
  };

  onAlertSelectWidgetGroup = ({ groupName }) => {
    const widgets = this.state.widgetGroups.find(
      (wg) => wg.groupName === groupName
    ).widgets;
    this.setState({
      selectedAlertWidgetGroup: groupName,
      selectedAlertColumn: null,
      widgets
    });
  };

  onNavigationTabSelect = (index) => {
    const { dispatch } = this.props;
    const { tabPageIdList } = this.state;

    const isGlobalSettingsPageInfoRequired =
      this.getIsGlobalSettingsPageInfoRequired(tabPageIdList[index]);

    if (isGlobalSettingsPageInfoRequired) {
      dispatch(
        getPageItemOperations({
          pageId: tabPageIdList[index]
        })
      );

      dispatch(
        getGlobalSettingsPageInfo({
          pageId: tabPageIdList[index]
        })
      );
    }

    this.props.history.push({ hash: `${sectionHashPrefix}${index}` });
    this.setState({
      selectedTab: index,
      isDataFetched: false,
      selectedAlertWidgetGroup: null,
      selectedAlertColumn: null,
      selectedAlertWidget: null
    });
  };

  renderBody = () => {
    const { groups, selectedAlertWidget, selectedAlertWidgetGroup } =
      this.state;
    const { settings } = this.props;
    const { configuration } = settings;

    return (
      <>
        <div className={style.bodyContainer}>
          <div className={style.bodyPanelContainer}>
            <div className="row">
              <div className="offset-md-10 col-md-2">
                <Button
                  type="primary"
                  disabled={configuration.isLoading}
                  onClick={this.onToggleAddGroupModal}
                  className={style.pullRight}>
                  + Add New Column
                </Button>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <WidgetTree
                  tree={this.state.widgetGroups}
                  selectedWidgetGroup={selectedAlertWidgetGroup}
                  selectedWidget={selectedAlertWidget}
                  onSelect={{
                    COLUMN: this.onAlertSelectColumn,
                    WIDGET: this.onAlertSelectWidget,
                    GROUP: this.onAlertSelectWidgetGroup
                  }}
                  onSortItems={{
                    COLUMN: this.onSortGroups,
                    WIDGET: this.onSortWidgets,
                    GROUP: this.onSortWidgetGroups
                  }}
                />
              </div>

              <div className="col-md-8">{this.renderGroupCards()}</div>
            </div>
          </div>
        </div>

        <div className={style.saveSequenceContainer}>
          <Button
            type="primary"
            disabled={groups.length === 0 || configuration.isLoading}
            onClick={this.onSaveSettings}
            className={style.sequenceButton}>
            Save Sequence
          </Button>
        </div>
      </>
    );
  };

  onHeadTabsChange = (index) => {
    this.setState(
      {
        selectedTab: index
      },
      () => console.log('this.state.selectedTab', this.state.selectedTab)
    );
  };

  render() {
    const { title2, title, tabList: tabList1, tabList2 } = this.props;
    const { isAddGroupModalShown, groups, tabList, createSegmentSetAccess } =
      this.state;
    const isDynamicPropertiesTabSelected =
      this.getIsDynamicPropertiesTabSelected();
    const isCurrentPipelinesTabSelected =
      this.getIsCurrentPipelinesTabSelected();

    return (
      <div className={style.mainContainer}>
        <AddNewGroupModal
          groups={groups}
          isShown={isAddGroupModalShown}
          onModalToggle={this.onToggleAddGroupModal}
          onConfirmClick={this.onConfirmAddGroup}
        />
        <StyledTab>
          <TabPane tab={title} key="1">
            <div>
              {' '}
              <div
                className={style.container}
                style={{ backgroundColor: '#fff' }}>
                <SettingsTabView
                  onTabSelect={this.onNavigationTabSelect}
                  tabList={tabList}
                  selectedTab={this.state.selectedTab}
                />
              </div>
              {isDynamicPropertiesTabSelected ||
              isCurrentPipelinesTabSelected ? (
                <>
                  {isDynamicPropertiesTabSelected ? (
                    <DynamicProperties
                      moduleId={this.state.moduleId}
                      subModule={this.state.subModule}
                    />
                  ) : null}
                  {isCurrentPipelinesTabSelected ? (
                    <Pipelines moduleId={this.state.moduleId} />
                  ) : null}
                </>
              ) : (
                <div>{this.renderBody()}</div>
              )}
            </div>
          </TabPane>
          {createSegmentSetAccess && (
            <TabPane tab={title2} key="2">
              <CreateSegementSets />
            </TabPane>
          )}
        </StyledTab>
      </div>
    );
  }
}

Settings.propTypes = {
  title: PropTypes.string,
  history: PropTypes.object
};

/**
 * mapStateToProps
 * @param state
 * @param ownProps
 * @returns {{ app: *, investigation: investigation, authentication: (authentication | { isAuthed: boolean }) }}
 */
function mapStateToProps(state, ownProps = {}) {
  return {
    app: state.app,
    settings: state.settings,
    authentication: state.authentication
  };
}

/**
 * mapDispatchToProps
 * @param dispatch
 * @param ownProps
 * @returns {{ dispatch: *}}
 */
function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    dispatch
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Settings));
